import NotFoundPage from '@map/components/NotFoundPage';
import { useCurrentUser } from '@map/hooks/userApi';
import { lazy, useMemo } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import GuestArea from '../GuestArea/GuestArea';
import { guestLinks } from '../GuestArea/links';
import { rootLinks } from './links';

// TODO: This is added just to make the tests pass, remove it after starting using the types
import { SkillSurveyApiSuccessResponseOf } from '@skill-survey/schema.utils';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type TestType = SkillSurveyApiSuccessResponseOf<'/{locale}/api/skill-survey/v1/occupations', 'get'>;

const InnerArea = lazy(() => import(/* webpackChunkName: "InnerArea" */ './InnerArea'));

const Root = () => {
  const user = useCurrentUser();

  const redirectTo = useMemo(() => {
    const isUserLoggedIn = !!user.id;
    if (!isUserLoggedIn) {
      return guestLinks.root();
    }
    return rootLinks.inner();
  }, [user.id]);

  return (
    <Switch>
      <Redirect exact from="/" to={redirectTo} />
      <Route path={rootLinks.inner()} component={InnerArea} />
      <Route path={guestLinks.root()} component={GuestArea} />
      <Route path="/error_test" component={() => (({}) as any).doABarrelRoll()} />
      <Route component={NotFoundPage} />
    </Switch>
  );
};

export default Root;
